import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./TextEditor.css";
const TextEditor = ({disabled , value , onChange , className}) => {
//   const [value, setValue] = useState("");
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // toggled buttons
      // ['blockquote', 'code-block'],

      // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ list: "ordered" }, { list: "bullet" }],
      // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ direction: "rtl" }], // text direction

      [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      // [{ 'font': [] }],
      [{ align: [] }],

      ["clean"],
    ],
  };

  // const formats = [
  //     'header',
  //     'bold', 'italic', 'underline', 'strike', 'blockquote',
  //     'list', 'bullet', 'indent',
  //     'link', 'image'
  //   ]
  // const darkMode = localStorage.getItem('theme') === 'dark' ? true : false;
  return (
    <div className={['TextEditorContainer' , disabled ? 'disabled' : null].join(' ')}>
      <ReactQuill
        className={className}
        // formats={formats}
        modules={modules}
        theme="snow"
        value={value}
        onChange={onChange}
      ></ReactQuill>
    </div>
  );
};
export default TextEditor;
